import './FlowNavigation.scss';

interface FlowNavigationProps {
    onPrev: () => void;
    onNext: () => void;
    prevLabel?: string;
    nextLabel?: string;
    isNextDisabled?: boolean;
    hideNextArrow?: boolean;
    hideNextButton?: boolean;
    className?: string;
}

export function FlowNavigation({
    onPrev,
    onNext,
    prevLabel = '이전',
    nextLabel = '다음',
    isNextDisabled = false,
    hideNextArrow = false,
    hideNextButton = false,
    className = ''
}: FlowNavigationProps) {
    return (
        <footer className={`flow-navigation ${className}`}>
            <button
                className="nav-btn nav-btn--prev"
                onClick={onPrev}
            >
                ← {prevLabel}
            </button>
            {!hideNextButton && (
                <button
                    className="nav-btn nav-btn--next"
                    disabled={isNextDisabled}
                    onClick={onNext}
                >
                    {nextLabel}{!hideNextArrow && ' →'}
                </button>
            )}
        </footer>
    );
}
